/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'radio',
  templateUrl: './radio.component.html',
})
export class RadioComponent implements ControlValueAccessor, OnInit {
  @Input() checkedValue!: string;
  @Input() disabled = false;
  @Input() class = '';
  @Input() labelBaseClass = '';
  @Input() inputClass = '';
  @Input() isRequired = false;

  model: any;

  constructor(@Self() private ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  checked = false;

  onChange: (modal: any) => void;
  onTouched: () => void;

  //#region ControlValueAccessor

  ngOnInit() {
    this.ngControl.control?.valueChanges.subscribe((value) => {
      if (this.model === value) {
        return;
      }
      this.writeValue(value);
    });
  }

  writeValue(value: any) {
    this.model = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  //#endregion

  onValueChanged() {
    this.model = this.model === this.checkedValue ? null : this.checkedValue;
    this.onChange(this.model);
  }
}
